import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141b19e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "transfer-box" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "index" }, "序号"),
  /*#__PURE__*/_createElementVNode("span", { class: "name" }, "名称"),
  /*#__PURE__*/_createElementVNode("span", { class: "operation" }, "操作")
], -1))
const _hoisted_8 = { class: "drag-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drag" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "drag-icon" })
], -1))
const _hoisted_10 = { class: "index" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "operation" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import { CODE_ENUM } from '@/common'
import { queryAppResourceList } from '@/api'
import { ArrowRight } from '@element-plus/icons-vue'
import Text from '@/components/text'
import draggable from 'vuedraggable'
import Steps from '@/components/steps'


export default /*#__PURE__*/_defineComponent({
  __name: 'package-form-step2',
  props: ['visible', 'data', 'steps', 'title', 'handSubmit'],
  emits: ['update:visible', 'on-checked'],
  setup(__props, { emit: __emit }) {

const treeRef = ref()

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  async () => {
    if (props.visible) {
      await queryResource()

      // 免费套餐
      const defaultChecked = getDefaultResource()

      const moResourceIds = props.data?.moResourceIds || []
      // 新建则默认勾选
      if (!moResourceIds.length) {
        checkResource.value = defaultChecked
      } else {
        checkResource.value = [...new Set(defaultChecked.concat(moResourceIds))]
      }
      // 移到右边
      checkToRight()
    }
  }
)

const cancel = () => {
  const rightCheckId = rightCheck.value.map((item: any) => {
    return item.id
  })

  $emit('update:visible', false)
  $emit('on-checked', rightCheckId)
  checkResource.value = []
  rightCheck.value = []
}

const loading = ref(false)
const handSubmit = async () => {
  loading.value = true
  const rightCheckId = rightCheck.value.map((item: any) => {
    return item.id
  })
  const valid: boolean = await props.handSubmit(rightCheckId).finally(() => {
    loading.value = false
  })
  valid && cancel()
}

const checkResource: any = ref([])
const checkChange = () => {
  const currentCheckIds = treeRef.value.getCheckedKeys()
  checkResource.value = resourceList.value
    .filter((_: any) => {
      return currentCheckIds.includes(_.id)
    })
    .map((_: any) => _.id)
}

// 除去顶级节点资源列表
const resourceList: any = ref([])
const resourceTreeList: any = ref([])

const detailLoading = ref(false)
const queryResource = async () => {
  detailLoading.value = true
  const res: any = await queryAppResourceList().finally(() => {
    detailLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    // resourceList.value = res.data || []
    let moResourceList: any = []

    const result = (res.data || []).map((item: any) => {
      const { id, name, resources } = item
      const children = (resources || []).map((_: any) => {
        return {
          label: _.name,
          id: _.id,
          name: _.name,
          isFreeResource: _.isFreeResource,
        }
      })
      moResourceList = moResourceList.concat(children)
      return {
        label: name,
        id,
        children,
      }
    })
    resourceTreeList.value = result
    resourceList.value = moResourceList
  }
}

const getDefaultResource = () => {
  return resourceList.value
    .filter((item: any) => {
      return item.isFreeResource
    })
    .map((item: any) => item.id)
}

// 右边展示的
const rightCheck = ref([])

const checkToRight = () => {
  const rightCheckId = rightCheck.value.map((item: any) => {
    return item.id
  })
  const result = resourceList.value.filter((item: any) => {
    return (
      checkResource.value.includes(item.id) && !rightCheckId.includes(item.id)
    )
  })
  rightCheck.value = rightCheck.value.concat(result)
  updateTreeData()
}

const showRemove = (id: any) => {
  return !getDefaultResource().includes(id)
}

const removeItem = (id: any) => {
  rightCheck.value = rightCheck.value.filter((item: any) => {
    return item.id !== id
  })
  updateTreeData()
}

const updateTreeData = () => {
  const rightCheckId = rightCheck.value.map((item: any) => {
    return item.id
  })
  const result = resourceTreeList.value.map((item: any) => {
    const children = item.children.map((v: any) => {
      return {
        ...v,
        disabled: rightCheckId.includes(v.id),
      }
    })
    const disabled = children.every((_: any) => _.disabled)
    return {
      ...item,
      disabled,
      children,
    }
  })
  resourceTreeList.value = result
}

return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: props.title,
    size: "1006px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_14, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 保存 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Steps), {
        "model-value": 2,
        steps: props.steps,
        class: "ws_mb25"
      }, null, 8, ["steps"]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(checkResource.value.length) + "/" + _toDisplayString(resourceList.value.length), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_tree, {
              onCheckChange: checkChange,
              ref_key: "treeRef",
              ref: treeRef,
              data: resourceTreeList.value,
              "node-key": "id",
              "show-checkbox": "",
              "default-expand-all": ""
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            onClick: checkToRight,
            class: "transfer"
          }, [
            _createVNode(_component_el_icon, {
              color: "#fff",
              size: "18"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_empty, { description: "暂未选择" })
          ], 512), [
            [_vShow, !rightCheck.value.length]
          ]),
          _createVNode(_unref(draggable), {
            modelValue: rightCheck.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rightCheck).value = $event)),
            "item-key": "id",
            class: "drag-box",
            handle: ".drag-icon"
          }, {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(Number(index + 1)), 1),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_unref(Text), {
                    content: element.name
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(element.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]),
                _createElementVNode("span", _hoisted_12, [
                  (showRemove(element.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (removeItem(element.id))
                      }, "删除", 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})